<template>
  <div class="animated fadeIn" ref="wrapper">
    <div class="kt-portlet kt-portlet--mobile" style="position: relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div
            class="d-flex flex-row justify-content-between align-items-center"
            style="margin-bottom: 2em"
          >
            <div style="width: 50%">
              <div><b>DREAM BETTING S.R.L</b></div>
              <div>CUI: 40594816</div>
              <div>J40/4671/2019</div>
              <div>
                Punct de lucru:
                {{ data && data.shop_name ? data.shop_name.name : "" }}
              </div>
              <div>LICENTA NR: L1193288F000949</div>
            </div>
          </div>
          <div
            class="
              mb-4
              d-flex
              flex-row
              justify-content-between
              align-items-center
            "
          >
            <div style="width: 20%"></div>
            <div style="width: 60%">
              <h2 class="text-center">Formular tranzactie ≥ 2.000 euro</h2>
              <p class="text-center mt-4">
                Conform art. 13, alin. (2) din Legea nr. 129 din 18.07.2019,
              </p>
              <p class="text-center">
                pentru prevenirea şi combaterea spălării banilor şifinanţării
                terorismului
              </p>
            </div>
            <div class="text-right print-display" style="width: 20%"></div>
          </div>
          <table class="mt-2 my-table">
            <tbody>
              <tr>
                <td>
                  Nume: <b>{{ data.player_name }}</b>
                </td>
                <td>
                  Prenume: <b>{{ data.player_surname }}</b>
                </td>
              </tr>
              <tr>
                <td>
                  CNP/: <b>{{ data.player_cnp }}</b>
                </td>
                <td>
                  <div class="d-flex flex-row flex-fill">
                    Serie si Nr. CI:
                    <div
                      class="line"
                      style="flex: 1; border-bottom: 1px dotted black"
                    ></div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="d-flex flex-row flex-fill">
                    Cetatenia:
                    <div
                      class="line"
                      style="flex: 1; border-bottom: 1px dotted black"
                    ></div>
                  </div>
                </td>
                <td>
                  <div class="d-flex flex-row flex-fill">
                    Tara de domiciliu:
                    <div
                      class="line"
                      style="flex: 1; border-bottom: 1px dotted black"
                    ></div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="d-flex flex-row flex-fill">
                    Data:
                    <b>{{ mom(data.timestamp / 1e9).format("DD-MM-YYYY") }}</b>
                  </div>
                </td>
                <td>
                  <div class="d-flex flex-row flex-fill">
                    Ora:
                    <b>{{ mom(data.timestamp / 1e9).format("HH:mm:ss") }}</b>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div class="d-flex flex-row flex-fill">
                    Suma: <b>{{ roundThousands(data.ticket_net_amount) }}</b>
                  </div>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <div class="mt-2 text-center">
            <b
              >Suma reprezinta castig din participarea la jocul de noroc tip
              pariuri in cota fixa Nr./Seria {{ data.ticket_serial }}</b
            >
          </div>
          <div class="mt-4">
            <p>
              <i>Prin prezenta, declar pe propria raspundere urmatoarele:</i>
            </p>
            <p>
              <i
                >- Sunt BENEFICIARUL REAL al sumei castigate prin participarea
                la jocurile de noroc de tip pariuri in cota fixa</i
              >
            </p>
            <p>
              <i
                ><b>{{
                  data &&
                  data.meta &&
                  data.meta.extra &&
                  data.meta.extra.real_beneficiary
                    ? "DA"
                    : "NU"
                }}</b></i
              >
            </p>

            <p class="mt-4"><i>- Sunt PERSOANA EXPUSA PUBLIC</i></p>
            <p>
              <i
                ><b>{{
                  data &&
                  data.meta &&
                  data.meta.extra &&
                  data.meta.extra.public_person
                    ? "DA"
                    : "NU"
                }}</b></i
              >
            </p>

            <p class="mt-4">
              <i
                >- Detin calitatea de membru al familiei al unei persoane expuse
                public ori de persoana cunoscuta ca asociat al unei persoane
                expuse public
              </i>
            </p>
            <p>
              <i
                ><b>{{
                  data &&
                  data.meta &&
                  data.meta.extra &&
                  data.meta.extra.related_to_public_person
                    ? "DA"
                    : "NU"
                }}</b></i
              >
            </p>

            <p><i>Semnatura jucator: </i></p>
            <p>
              <i
                >Colectarea si prelucrarea datelor de la participantii de joc,
                prin atasarea unei copii a cartii de identitate, este realizata
                conform Art. 6. alin (1), lit.c din Regulamentul nr. 679 din 27
                aprilie 2016 privind protectia persoanelor fizice in ceea ce
                priveste prelucrarea datelor cu caracter personal si privind
                libera circulatie a acestor date:”Prelucrarea este legală numai
                dacă şi în măsura în care se aplică cel puţin una dintre
                următoarele condiţii:….c) prelucrarea este necesară în vederea
                îndeplinirii unei obligaţii legale care îi revine
                operatorului”.</i
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

function unescape(str) {
  return (str + "===".slice((str.length + 3) % 4))
    .replace(/-/g, "+")
    .replace(/_/g, "/");
}

function decode(str, encoding) {
  return Buffer.from(unescape(str), "base64").toString(encoding || "utf8");
}

export default {
  name: "onlinePayoutsPrinting",
  data: function () {
    return {
      tableName: "onlinePayoutsPrinting",

      data: {},

      isBusy: false,

      scrollHeight: 0,
      datePrint: moment(),
      type: "",
    };
  },
  mounted() {
    let data = this.$router.history.current.query.data;
    data = decode(data);
    console.log("data:", data);
    const queryParms = JSON.parse(data);

    this.data = queryParms;

    if (queryParms.lang)
      this.$store.dispatch("global/setLanguage", queryParms.lang);

    const self = this;
    this.intervalID = window.setInterval(() => {
      if (self.$refs.wrapper) {
        const newHeight = self.$refs.wrapper.scrollHeight;
        if (newHeight != self.scrollHeight) {
          self.scrollHeight = newHeight;
          self.sendMessage(
            JSON.stringify({ type: "resize", height: newHeight })
          );
        }
      }
    }, 100);

    this.onMessageCB = this.onMessage.bind(this);
    this.bindEvent(window, "message", this.onMessageCB);
  },
  destroyed() {
    window.clearInterval(this.intervalID);
    this.unbindEvent(window, "message", this.onMessageCB);
  },
  methods: {
    mom(val) {
      return moment.unix(val);
    },
    onMessage(e) {
      let data = {};
      try {
        data = JSON.parse(e.data);
      } catch (err) {
        // noop
      }
      if (data) {
        if (data.type && data.type == "print") {
          this.datePrint = moment();
          this.$nextTick(() => {
            window.print();
          });
        }
      }
    },
    bindEvent(element, eventName, eventHandler) {
      if (element.addEventListener) {
        element.addEventListener(eventName, eventHandler, false);
      } else if (element.attachEvent) {
        element.attachEvent("on" + eventName, eventHandler);
      }
    },
    unbindEvent(element, eventName, eventHandler) {
      if (element.removeEventListener) {
        element.removeEventListener(eventName, eventHandler, false);
      } else if (element.attachEvent) {
        element.detachEvent("on" + eventName, eventHandler);
      }
    },
    sendMessage(msg) {
      // Make sure you are sending a string, and to stringify JSON
      window.parent.postMessage(msg, "*");
    },
    roundThousands(value) {
      if (typeof value == "string") return value;
      if (!value) return "0.00";

      const decimals = 2;
      const tmp = value / 10000;

      const res = Number(
        Math.round(tmp + "e" + decimals) + "e-" + decimals
      ).toFixed(decimals);
      return res.replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
  },
};
</script>
<style lang="css">
body {
  background-color: #fff !important;
}
@page {
  size: A4;
  margin: 0;
}
@media print {
  html,
  body {
    width: 210mm;
    height: 297mm;
  }
  #operators-report-table-printing {
    border-color: #000 !important;
    border-width: 1px 0 0 1px !important;
  }
  #operators-report-table-printing > thead > tr > th {
    border-color: #000 !important;
    border-width: 0 1px 1px 0 !important;
  }
  #operators-report-table-printing > tbody > tr > td {
    border-color: #000 !important;
    border-width: 0 1px 1px 0 !important;
  }
}
</style>
<style lang="scss" scoped>
.kt-portlet {
  margin-bottom: 0;
  padding: 2em;
  border-radius: 0;
  color: #000;
}
h2,
h3 {
  color: #000;
}
.print-display {
  opacity: 0;
}
@media print {
  .kt-portlet {
    font-size: 20px;
  }
  .print-display {
    opacity: 1;
  }
}

.my-table {
  margin: 0 20px;
  width: calc(100% - 40px);

  td {
    padding: 10px 20px;

    .line,
    b {
      margin-left: 10px;
    }
  }
}
</style>
